import React, { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { useWallet } from '@solana/wallet-adapter-react';
import './TransactionList.css';

function TransactionsTable() {
    const { publicKey } = useWallet(); // Access the connected wallet's publicKey
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!publicKey) return;

        setLoading(true);
        const q = query(
            collection(db, 'shlot_pulls'),
            // where('publicKey', '==', publicKey.toBase58()),
            orderBy('timestamp', 'desc')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedTransactions = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setTransactions(fetchedTransactions);
            setLoading(false);
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [publicKey]);

    const downloadCSV = () => {
        if (transactions.length === 0) return;

        const headers = ['Wallet', 'Timestamp', 'Total Score', 'Match Result', 'Transaction ID'];
        const rows = transactions.map((tx) => [
            tx.publicKey,
            new Date(tx.timestamp).toLocaleString(),
            tx.totalScore,
            tx.matchResult,
            tx.transactionId
        ]);

        const csvContent = [
            headers.join(','),
            ...rows.map(row => row.map(value => `"${value}"`).join(','))
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'transactions.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (!publicKey) {
        return <p>Please connect your wallet to view your transactions.</p>;
    }

    if (loading) {
        return <p>Loading transactions...</p>;
    }

    return (
        <div className="transactions-list">
            <h2>All Transactions</h2>
            <div className="transaction-list-table-container">
                {transactions.length === 0 ? (
                    <p>No transactions found for this wallet.</p>
                ) : (
                    <>
                        <button onClick={downloadCSV} className="download-button">Download CSV</button>
                        <table>
                            <thead>
                            <tr>
                                <th>Wallet</th>
                                <th>Timestamp</th>
                                <th>Total Score</th>
                                <th>Match Result</th>
                                <th>Transaction ID</th>
                                <th>Transaction Link</th>
                            </tr>
                            </thead>
                            <tbody>
                            {transactions.map((tx) => (
                                <tr key={tx.id}>
                                    <td>{tx.publicKey}</td>
                                    <td>{new Date(tx.timestamp).toLocaleString()}</td>
                                    <td>{tx.totalScore}</td>
                                    <td>{tx.matchResult}</td>
                                    <td>{tx.transactionId}</td>
                                    <td>
                                        <a
                                            href={`https://solscan.io/tx/${tx.transactionId}?cluster=mainnet`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            View on Solscan
                                        </a>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </>
                )}
            </div>
        </div>
    );
};

export default TransactionsTable;
